/** API Endpoints */

import { environment } from '../../../environments/environment';

/** Dynamic endpoint builders */

// Auth endpoints (public)
export const OPE_AUTH_SEND_OTP = `${environment.apiUrl}/public/ope/auth/send-otp`;
export const OPE_AUTH_VERIFY_OTP = `${environment.apiUrl}/public/ope/auth/verify-otp`;
export const OPE_AUTH_CREATE_BORROWER = `${environment.apiUrl}/public/ope/auth/borrower`;

// Application endpoints (public)
export const OPE_APPLICATION_CREATER = `${environment.apiUrl}/public/ope/application/create`;
export const OPE_APPLICATION_DECLINE = `${environment.apiUrl}/public/ope/application/decline`;
export const OPE_APPLICATION_SEND_OTP = `${environment.apiUrl}/public/ope/application/send-otp`;
export const OPE_APPLICATION_VERIFY_OTP = `${environment.apiUrl}/public/ope/application/verify-otp`;

// Style endpoints (public)
export const OPE_STYLES_GET = (supplierId: string) => `${environment.apiUrl}/public/ope/style/${supplierId}`;

// Session endpoint (public)
export const OPE_SESSION_GET = (sessionId: string) => `${environment.apiUrl}/public/ope/session/${sessionId}`;

// Session endpoints (internal)
export const OPE_FLAGS_GET = (sessionId: string) => `${environment.apiUrl}/internal/ope/flags/${sessionId}`;
export const OPE_SESSION_CLOSE = `${environment.apiUrl}/internal/ope/session/close`;
export const OPE_AUTHORIZATION_CREATE = `${environment.apiUrl}/internal/ope/authorization/create`;
